// extracted by mini-css-extract-plugin
export default {"root":"PageLayout_root__-x2As","loaderContainer":"PageLayout_loaderContainer__vLNDg","pageContainer":"PageLayout_pageContainer__32kO7","loader":"PageLayout_loader__NhRj8"};